import { c as _c } from "react/compiler-runtime";
import { FloatingCard } from '@components/floating';
import { Skeleton } from '@endurancewarranty/ui';
import type { FC } from 'react';
export const LoadingCallScript: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FloatingCard.Header title="Call Script" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FloatingCard openOnMount={true} pinOnMount={true}>{t0}<FloatingCard.Content className="flex flex-col gap-3"><Skeleton className="mt-4 h-5 w-2/3" /><Skeleton className="h-5 w-5/6" /><Skeleton className="h-5 w-3/4" /><Skeleton className="mb-12 h-5 w-1/4" /></FloatingCard.Content></FloatingCard>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};